module.exports = __webpack_public_path__ + "img/item-check.7896dce9.svg";